import { render, staticRenderFns } from "./devis.vue?vue&type=template&id=9028c64e&scoped=true&"
import script from "./devis.vue?vue&type=script&lang=js&"
export * from "./devis.vue?vue&type=script&lang=js&"
import style0 from "./devis.vue?vue&type=style&index=0&id=9028c64e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9028c64e",
  null
  
)

export default component.exports